export const KNOWLEDGE_BASE_URL = {
  PREBID_TIMEOUTS: 'https://knowledge-base.yieldbird.com/prebid-stack/timeouts',
} as const
